import { handleActions } from 'redux-actions';
import {} from './actions';
import { TierManageContentStoreSlice } from './types';

const handler = handleActions<TierManageContentStoreSlice, any>({}, {});

export default handler;
